import { formatCurrencyValues } from "../../utils/convertUtils";

const mapCard = (json) => {
    const {
        Taxonomy,
        SumBalDebitCurrent,
        SumBalCreditCurrent,
        SumBalDebitN1,
        SumBalCreditN1,
        SumBalDebitN2,
        SumBalCreditN2,
        SumBalDebitN3,
        SumBalCreditN3,
        CurrencyOptions,
        DebitCreditIndicator,
    } = json;

    return [
        [{ labels: ["Taxonomy"], value: Taxonomy, type: "string", basis: "33%" }],
        [
            {
                labels: ["DebitCreditIndicator"],
                value: DebitCreditIndicator,
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["SumBalDebitCurrent"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebitCurrent),
                type: "currency",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["SumBalCreditCurrent"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCreditCurrent),
                type: "currency",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["SumBalDebitN1"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebitN1),
                type: "currency",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["SumBalCreditN1"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCreditN1),
                type: "currency",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["SumBalDebitN2"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebitN2),
                type: "currency",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["SumBalCreditN2"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCreditN2),
                type: "currency",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["SumBalDebitN3"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebitN3),
                type: "currency",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["SumBalCreditN3"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCreditN3),
                type: "currency",
                basis: "10%",
            },
        ],
    ];
};

const header = [
    { label: ["Taxonomy"], align: "left", basis: "33%" },
    { label: ["Debit Credit Indicator"], align: "center" },
    { label: ["Current - Debit"], align: "right", basis: "10%" },
    { label: ["Current - Credit"], align: "right", basis: "10%" },
    { label: ["N-1 Debit"], align: "right", basis: "10%" },
    { label: ["N-1 Credit"], align: "right", basis: "10%" },
    { label: ["N-2 Debit"], align: "right", basis: "10%" },
    { label: ["N-2 Credit"], align: "right", basis: "10%" },
    { label: ["N-3 Debit"], align: "right", basis: "10%" },
    { label: ["N-3 Credit"], align: "right", basis: "10%" },
];

const mapper = (json, card) => {
    const { TaxonomyCode, DebitCreditIndicator } = json;
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/reports/nc_trial_balance",
            appendFilters: ["CLB_Period"],
            filter: [
                { filters: [{ value: TaxonomyCode }], column: "TaxonomyCode" },
                {
                    filters: [
                        {
                            value: DebitCreditIndicator,
                        },
                    ],
                    column: "DebitCreditIndicator",
                },
            ],
        },
    };
};

const nctrialbalancetaxonomypluriannualMapper = {
    map: mapper,
    header,
};

export default nctrialbalancetaxonomypluriannualMapper;
